import { useState } from 'react'
import { useQuery } from '@apollo/client'
import { useGlobalSearchParams } from 'expo-router'

import { PAGE_SIZE } from '@/constants/common'
import { GET_BUY_ORDER_CONNECTION, GET_SELL_ORDER_CONNECTION } from '@/constants/graphql/queries'
import type { OrderListParams } from '@/types/common'
import { getOpenBuyStatusFromFilter } from '@/utils/order'
import FastTrackOrderList from '@/components/FastTrackOrderList'
import OrderList from '@/components/OrderList'

// const POLL_INTERVAL = 60000

export default function OpenScreen() {
  const { action = 'buy' } = useGlobalSearchParams<OrderListParams>()

  if (action === 'fast-track') {
    return <FastTrackOrderList status={'open'} />
  }

  if (action === 'buy') {
    return <BuyOpenScreen />
  } else {
    return <SellOpenScreen />
  }
}

function BuyOpenScreen() {
  const { filter = 'all' } = useGlobalSearchParams<OrderListParams>()
  const [isFetchingMore, setIsFetchingMore] = useState(false)
  const { loading, data, fetchMore, refetch } = useQuery(GET_BUY_ORDER_CONNECTION, {
    // pollInterval: POLL_INTERVAL,
    variables: {
      status: getOpenBuyStatusFromFilter(filter),
      last: PAGE_SIZE,
      buyerId: '1' // HACK: hardcode buyerId since this doesn't actually get used
    }
  })

  async function handleFetchMore() {
    if (data?.getBuyOrderConnection.pageInfo.hasPreviousPage) {
      setIsFetchingMore(true)
      try {
        await fetchMore({
          variables: {
            status: getOpenBuyStatusFromFilter(filter),
            last: PAGE_SIZE,
            buyerId: '1',
            before: data?.getBuyOrderConnection.pageInfo.startCursor
          }
        })
      } finally {
        setIsFetchingMore(false)
      }
    }
  }

  return (
    <OrderList
      status={'open'}
      action={'buy'}
      isLoading={loading}
      filter={filter}
      data={data?.getBuyOrderConnection.edges.toReversed()}
      refetch={refetch}
      onFetchMore={handleFetchMore}
      isFetchingMore={isFetchingMore}
    />
  )
}

function SellOpenScreen() {
  const { filter = 'all' } = useGlobalSearchParams<OrderListParams>()
  const [isFetchingMore, setIsFetchingMore] = useState(false)
  const { loading, data, fetchMore, refetch } = useQuery(GET_SELL_ORDER_CONNECTION, {
    // pollInterval: POLL_INTERVAL,
    variables: {
      last: PAGE_SIZE,
      seller: '1' // HACK: hardcode buyerId since this doesn't actually get used
    }
  })

  async function handleFetchMore() {
    if (data?.getSellOrderConnection.pageInfo.hasPreviousPage) {
      setIsFetchingMore(true)
      try {
        await fetchMore({
          variables: {
            last: PAGE_SIZE,
            seller: '1',
            before: data?.getSellOrderConnection.pageInfo.startCursor
          }
        })
      } finally {
        setIsFetchingMore(false)
      }
    }
  }

  return (
    <OrderList
      status={'open'}
      action={'sell'}
      isLoading={loading}
      filter={filter}
      data={data?.getSellOrderConnection.edges.toReversed()}
      refetch={refetch}
      onFetchMore={handleFetchMore}
      isFetchingMore={isFetchingMore}
    />
  )
}
